const FormWrapper = ({ children }) => {
  return (
    <div className="my-5 bg-cream-50 px-6 py-12 shadow-hairline sm:rounded-card sm:px-12">
      {children}
    </div>
  );
};

export default FormWrapper;
